module.exports = __webpack_public_path__ + "img/message-text.bc39c91a.svg";